// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-container{border-style:solid;border-color:#000;border-width:1px}.custom-container>div>div:nth-of-type(1){background-color:rgba(35,47,62,.9450980392) !important;color:#fff !important}.custom-container>div>div:nth-of-type(1)>div>div>div>div{color:#fff !important}", ""]);
// Exports
module.exports = exports;
